import React, { useState } from 'react';


const escrowData = [
  {
    id: 1,
    status: 'offers',
    agent: {
      name: 'Jennifer Coolidge',
      image: '/images/agent2.jpg', // Frau
      type: 'LEAD'
    },
    property: {
      address: '4529 Eastern Bay Street',
      city: 'Plano',
      state: 'Texas',
      zip: '75024',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      offer: 'January 21, 2024',
      deadline: 'None'
    }
  },
  {
    id: 2,
    status: 'under_contract',
    agent: {
      name: 'Thomas Wilmington',
      image: '/images/agent1.jpg', // Mann
      type: 'LEAD'
    },
    property: {
      address: '4529 Eastern Bay Street',
      city: 'Plano',
      state: 'Texas',
      zip: '75024',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      executed: 'January 21, 2024',
      close: 'February 21, 2024'
    }
  },
  {
    id: 3,
    status: 'pending',
    agent: {
      name: 'Ashley Jedd',
      image: '/images/agent2.jpg', // Frau
      type: 'LEAD'
    },
    property: {
      address: '4529 Eastern Bay Street',
      city: 'Plano',
      state: 'Texas',
      zip: '75024',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      executed: 'January 21, 2024',
      close: 'February 21, 2024'
    }
  },
  {
    id: 4,
    status: 'closed',
    agent: {
      name: 'Rose Saunders',
      image: '/images/agent2.jpg', // Frau
      type: 'LEAD'
    },
    property: {
      address: '4529 Eastern Bay Street',
      city: 'Plano',
      state: 'Texas',
      zip: '75024',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      close: 'January 21, 2024'
    },
    commission: '$11,459'
  },
  {
    id: 5,
    status: 'offers',
    agent: {
      name: 'Stephanie & Paul Bankerson',
      image: '/images/agent2.jpg', // Frau
      type: 'LEAD'
    },
    property: {
      address: '4529 Eastern Bay Street',
      city: 'Plano',
      state: 'Texas',
      zip: '75024',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      offer: 'January 21, 2024',
      deadline: 'None'
    }
  },
  {
    id: 6,
    status: 'under_contract',
    agent: {
      name: 'Katherine Beckinsdale',
      image: '/images/agent2.jpg', // Frau
      type: 'LEAD'
    },
    property: {
      address: '4529 Eastern Bay Street',
      city: 'Plano',
      state: 'Texas',
      zip: '75024',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      executed: 'January 21, 2024',
      close: 'February 21, 2024'
    }
  },
  {
    id: 7,
    status: 'pending',
    agent: {
      name: 'Katherine Beckinsdale',
      image: '/images/agent2.jpg', // Frau
      type: 'LEAD'
    },
    property: {
      address: '4529 Eastern Bay Street',
      city: 'Plano',
      state: 'Texas',
      zip: '75024',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      executed: 'January 21, 2024',
      close: 'February 21, 2024'
    }
  },
  {
    id: 8,
    status: 'closed',
    agent: {
      name: 'James Buffet',
      image: '/images/agent1.jpg', // Mann
      type: 'LEAD'
    },
    property: {
      address: '4178 Melrose Lane',
      city: 'Lake Dallas',
      state: 'Texas',
      zip: '76031',
      image: '/images/property1.jpg',
      mlsNumber: 'MLS# 4901848'
    },
    dates: {
      close: 'January 21, 2024'
    },
    commission: '$34,129'
  }
];



const EscrowDashboard = () => {
    const [activeFilter, setActiveFilter] = useState('all');
  
    const statusCounts = escrowData.reduce((acc, item) => {
      acc[item.status] = (acc[item.status] || 0) + 1;
      return acc;
    }, {});
  
    const filteredData = escrowData.filter(item => 
      activeFilter === 'all' || item.status === activeFilter
    );
  
    const statusTypes = [
      { id: 'offers', label: 'Offers Made', color: 'bg-orange-400' },
      { id: 'under_contract', label: 'Under Contract', color: 'bg-orange-400' },
      { id: 'pending', label: 'Pending', color: 'bg-orange-400' },
      { id: 'closed', label: 'Closed', color: 'bg-orange-400' }
    ];
  
    const FilterTab = ({ status, isActive, onClick }) => (
      <div 
        className={`p-4 cursor-pointer transition-colors duration-200 rounded-lg shadow-sm bg-white
          ${isActive ? 'bg-gray-100 border-orange-400 border-2' : 'hover:bg-gray-50'}`}
        onClick={onClick}
      >
        <div className="flex justify-between items-center">
          <span className="font-semibold">{status.label}</span>
          <span className={`${status.color} text-white px-2 py-1 rounded-full text-sm`}>
            {statusCounts[status.id] || 0}
          </span>
        </div>
      </div>
    );
  
    const EscrowCard = ({ escrow }) => {
      const getDateDisplay = () => {
        switch (escrow.status) {
          case 'offers':
            return [
              { label: 'Offer Date', value: escrow.dates.offer },
              { label: 'Deadline', value: escrow.dates.deadline }
            ];
          case 'under_contract':
          case 'pending':
            return [
              { label: 'Executed Date', value: escrow.dates.executed },
              { label: 'Close Date', value: escrow.dates.close }
            ];
          case 'closed':
            return [
              { label: 'Close Date', value: escrow.dates.close },
              { label: 'Commission', value: escrow.commission }
            ];
          default:
            return [];
        }
      };
  
      return (
        <div className="bg-white rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-200">
          <div className="relative">
            <img
              src={escrow.property.image}
              alt={`Property at ${escrow.property.address}`}
              className="w-full h-48 object-cover"
            />
            <div className="absolute bottom-4 left-4">
              <div className="relative">
                <img
                  src={escrow.agent.image}
                  alt={escrow.agent.name}
                  className="w-12 h-12 rounded-full border-2 border-white"
                />
                <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                  {escrow.agent.type}
                </span>
              </div>
            </div>
          </div>
          
          <div className="p-4">
            <h3 className="font-semibold text-lg mb-1">{escrow.agent.name}</h3>
            <p className="text-sm text-gray-600">{escrow.property.address}</p>
            <p className="text-sm text-gray-600">
              {escrow.property.city}, {escrow.property.state} {escrow.property.zip}
            </p>
            <p className="text-sm text-gray-500 mt-1">{escrow.property.mlsNumber}</p>
            
            <div className="mt-4 space-y-2">
              {getDateDisplay().map((item, index) => (
                <div key={index} className="flex justify-between text-sm">
                  <span className="text-gray-600">{item.label}</span>
                  <span>{item.value}</span>
                </div>
              ))}
            </div>
            
            <button className="w-full mt-4 bg-red-500 text-white py-2 rounded-md hover:bg-red-600 transition-colors duration-200">
              Details
            </button>
          </div>
        </div>
      );
    };
  
    return (
      <div className="p-6 bg-gray-100 min-h-screen">
      <div className="flex justify-start items-center mb-6">
        <button className="bg-[#94CA3C] hover:bg-[#a1e632] text-white px-4 py-2 rounded-md flex items-center gap-2 transition-colors duration-200">
          <span>+ ADD ESCROW</span>
        </button>
        </div>
  
        <div className="grid grid-cols-4 gap-4 mb-6">
          {statusTypes.map(status => (
            <FilterTab
              key={status.id}
              status={status}
              isActive={activeFilter === status.id}
              onClick={() => setActiveFilter(status.id)}
            />
          ))}
        </div>
  
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {filteredData.map((escrow) => (
            <EscrowCard key={escrow.id} escrow={escrow} />
          ))}
        </div>
      </div>
    );
  };
  
  export default EscrowDashboard;
